export const formatCardNumber = (cardNumber: string) => {
  if (!cardNumber) return '*'
  cardNumber = cardNumber
    .replace(/[^\dA-Z]/g, '')
    .replace(/(.{4})/g, '$1 ')
    .trim()
  return cardNumber.replace(/X/g, '*')
}
